import { render } from "./ClientDescriptionView.vue?vue&type=template&id=0977c456&scoped=true"
import script from "./ClientDescriptionView.vue?vue&type=script&lang=js"
export * from "./ClientDescriptionView.vue?vue&type=script&lang=js"

import "./ClientDescriptionView.vue?vue&type=style&index=0&id=0977c456&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0977c456"]])

export default __exports__